
import { Vue, Component } from 'vue-property-decorator';
import image from '@/assets/image.png';

@Component
export default class ActivityAules extends Vue {
  image = image;
}
